import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import { HeroSection } from 'apps/promo/components/common/sections/HeroSection';
import { TextComponent } from 'apps/promo/components/common/sections/styles';
import { TilesSection } from 'apps/promo/components/common/sections/TilesSection';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';

const PartnersPage = (props) => {
    return (
        <PromoPageContainer bgColor="eggshell03">
            {props.heroTitle && (
                <HeroSection title={props.heroTitle} text={props.heroText} data={props.heroData} btnVariant="primary" noIconBtn isInvertedBtn />
            )}
            {props.tiles3 && (
                <ColoredSectionContainer>
                    <TextComponent>
                        <TilesSection data={props.tiles3} grayText />
                    </TextComponent>
                </ColoredSectionContainer>
            )}
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroData: state.extra?.strapiApi?.hero_block,
        tiles3: state.extra?.strapiApi?.tiles_section3,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(PartnersPage));
